import React, { useEffect } from "react";
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { Modal, Typography, Grid, Breadcrumbs, Menu, MenuItem, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTheme } from "@mui/material/styles";
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody";
import Button from "../../components/CustomButtons/Button.jsx";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { mongoUrl } from '../../components/shared/mongoUrl';
import CreatableSelect from 'react-select/creatable';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw } from 'draft-js';
import LazyCKEditor from "../../components/shared/LazyCKEditor.jsx";
import { baseUrl } from '../../components/shared/baseUrl';

function Createmod() {
  return (
    <LazyCKEditor
      data="<p>Start writing here...</p>"
      onChange={(event, editor) => {
        console.log(editor.getData());
      }}
    />
  );
}
const styles = (theme) =>({
    cardCategoryWhite: {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    cardTitleWhite: {
      color: "#FFFFFF",
      marginTop: "0px",
      minHeight: "auto",
      fontWeight: "300",
      fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
      marginBottom: "3px",
      textDecoration: "none",
      align: "center"
    },
    paper1: {
        position: 'absolute',
        width: 300,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
      },
      modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
      heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    }
  });

  const previewStyle = {
    maxHeight: "800px",
    maxWidth: "800px"
  }

export default function ViewModule(props) {
       
    const theme = useTheme()
    const classes = styles(theme);
    const [assignClick, setassignClick] = React.useState(null);
    const [currentClass, setcurrentClass] = React.useState(null);
    const [module, setmodule] = React.useState('');
    const [clas, setclas] = React.useState([]);
    const [currentclas, setcurrentclas] = React.useState([]);
    const [loading, setloading] = React.useState(true);
    const [intro, setintro]= React.useState(EditorState.createEmpty())
    const [back, setback]= React.useState(EditorState.createEmpty())
    const [task, settask]= React.useState(EditorState.createEmpty())
    const [mat, setmat]= React.useState(EditorState.createEmpty())
    const [met, setmet]= React.useState(EditorState.createEmpty())
    const [analysis, setanalysis]= React.useState(EditorState.createEmpty())
    const [expanded, setExpanded] = React.useState(false);

    const[selectedModule, setselectedModule] = React.useState('')
    const[selectedModuleId, setselectedModuleId]= React.useState('')
    const[openModalAdd, setopenModalAdd]=React.useState(false)
    const { modId, classId } = useParams();
    
    
    useEffect(() => {

        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();

        const loadData=()=>{


        const id = modId;
        //console.log(id);
        try{

        axios.get(`${baseUrl}class`, { cancelToken: source.token })
        .then((response) => {
        setclas(response.data)
        //console.log(response.data)
        const currentClas=Array.from(response.data).filter((cls)=> cls._id == classId)
        console.log(currentClas)
        setcurrentclas(currentClas)
            axios.get(`${baseUrl}modules/${modId}`,  { cancelToken: source.token })
            .then((response) => {
            setmodule(response.data)
            setloading(false)
            })

        })
        .catch((error)=>{
        console.log(error);
        });
    } catch (error) {
        if (axios.isCancel(error)) {
          console.log("cancelled");
        } else {
          throw error;
        }
      }

    };

    loadData();

    return() => {source.cancel();
    };


    }, []);

    const checkLink = (text) =>{
        console.log(text)
        if(text.indexOf("http")>=0){
            // console.log('link exists')
            // console.log(text.indexOf('http'))
            var start = text.indexOf('http');
            var end = start
            var strlen = 0;
            while(text[end]!==' '){
                //str = str + text[start];
                strlen++
                end++
            }
            // console.log(text.substring(start, end))
            return(
                <div>
                {text.substring(0, start)}
                <Link to ={{pathname:text.substring(start, end)}} target="_blank">
                    {text.substring(start, end)}
                </Link>
                </div>
            );

        }
    }

    const allLink = (text, k) =>{

        var len = text.length;
        var flag=false;
        console.log(text[k])

        for(var i=k; i<len; i++){
            if(text.substring(i, i+4)==="http"){
                // console.log('New Link at ' + i)
                flag=true;
                var start = i;
                var end = i;
                while(text[end]!==' '){
                    end++
                }
                // console.log(text.substring(start, end--))
                return(
                    <div>
                        {text.substring(k, start)}
                        <Link to ={{pathname:text.substring(start, end--)}} target="_blank">
                            {text.substring(start, end--)}
                        </Link>
                        {allLink(text, end)}
                    </div>
                       
                );
                
            }    
        }
        if(flag===false){
            return(
                <div>
                    {text.substring(k)}
                </div>
            );
        }

    }

    const handleButtonClick = (event) => {
        setassignClick(event.currentTarget)
      
      };
    const handleClose = () => {
        setassignClick(null);

      };

      const handleClassClose = () => {
        setcurrentClass(null);
      };

    const handleCurrentClass = event => {
        setcurrentClass(event.currentTarget)
      };

      function datepartial(date){
            
        var st = new Date(date).toString();
        return(
            st.substring(0, 21)
        );
    }

    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
      };
   
      const htmlPage = () =>{
        if(typeof window.GGBApplet !== 'undefined'){
          var ggbApp = new window.GGBApplet({filename:`${baseUrl}fileupload/files/${module.simulation}`, "width": 1200, "height": 800, "showFullscreenButton":true }, true);
        }

        const apploader = () =>{

       //window.addEventListener("load", function() {
            console.log('Loading simulation')
            ggbApp.inject('ggb-element');
         //        })
                }
        return(
          <div id="header" className="row">
          <meta name='viewport' content="width=device-width,initial-scale=1"></meta>
          <meta charSet="utf-8"/>
            <div id="ggb-element">
            </div>
            
            {apploader()}
          </div>

        );

      }

     const AssignModule=(id, name)=>{

        
          setselectedModule(name)
          setselectedModuleId(id)
          //moduleSelected: !this.state.moduleSelected,
          setopenModalAdd(!openModalAdd)
    
    
    
      }

     const handleCloseModal=()=> {
        setopenModalAdd(!openModalAdd)

      }
      const AssignYesModule =()=>{

        // this.setState({
        //   moduleSelected: !this.state.moduleSelected,
        //   openModalAdd:!this.state.openModalAdd
    
        // })
        setopenModalAdd(!openModalAdd)

        window.location = `/admin/dashboard/createsession/${classId}/${selectedModuleId}`
    
    
      }
    
      const AssignNoModule=()=>{
    
        // this.setState({
        // //   selectedModule:'',
        //    selectedModuleId: '',
        //   openModalAdd:!this.state.openModalAdd
    
        // })
        setselectedModuleId('')
        setopenModalAdd(!openModalAdd)

    
      }

      const custom_config = {
        extraPlugins: [ MyCustomUploadAdapterPlugin ],
        
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            'link',
            'bulletedList',
            'numberedList',
            '|',
            'blockQuote',
            'insertTable',
            '|',
            'imageUpload',
            'undo',
            'MathType',
            'SpecialCharacters',
            'SpecialCharactersMathematical',
            'redo',
            'Subscript', 
            'Superscript',            
          ]
        }
        ,
        table: {
          contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
        }
      }
    
            //////Code for ckeditor
            function MyCustomUploadAdapterPlugin(editor){
                editor.plugins.get( 'FileRepository' ).createUploadAdapter = (loader) => {
                  return new MyUploadAdapter(loader)
                }
              }
          
              class MyUploadAdapter {
                constructor(props) {
                    // CKEditor 5's FileLoader instance.
                  this.loader = props;
                  // URL where to send files.
                  this.url = `${baseUrl}fileupload/files`;
                }
            
                // Starts the upload process.
                upload() {
                  return this.loader.file
                      .then( file => new Promise( ( resolve, reject ) => {
          
                          const toBase64 = file => new Promise((resolve, reject) => {
                              const reader = new FileReader();
                              reader.readAsDataURL(file);
                              reader.onload = () => resolve(reader.result);
                              reader.onerror = error => reject(error);
                          });
                          
                          return toBase64(file).then(cFile=>{
                            console.log(file)
                            const data=new FormData();
                            data.append('file', file)   
                            var filename = '';
                          axios.post(`${baseUrl}fileupload/files`, data)
                                  .then((response) => {
                                      console.log(response.data.file.filename)
                                      filename = response.data.file.filename;
                                      resolve({ 
                                        default: `${baseUrl}fileupload/files/${filename}` 
                                      })
                                  })
                                  .catch((error)=>{
                                      reject(`Couldn't upload file: ${ file.name }.`)
                                    console.log(error);
                                    });
                                  })
                          
                      } ) );
              }
            
            }
          
      //console.log(clas)
    
    return(
        
        loading!==true? 

        <GridContainer>
            <GridItem xs={12} sm={12} md={8}>

            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                {typeof classId!=='undefined'?
                <Link color="inherit" to="/admin/dashboard">
                    Dashboard
                </Link>:
                    <Link color="inherit" to="/admin/home">
                        Home
                    </Link>
                }
                {typeof classId!=='undefined'?
                <Link color="inherit" to={`/admin/dashboard/viewclass/${currentclas[0]._id}`}> 
                    <Typography color="textPrimary">{currentclas[0].title}</Typography>
                </Link>
                :null
                }
                {typeof classId!=='undefined'?
                <Link color="inherit" to={`/admin/dashboard/createsession/${classId}`}> 
                    <Typography color="textPrimary">Create new Session</Typography>
                </Link>:null}
                {typeof classId!=='undefined'?
                <Link color="inherit" to={`/admin/dashboard/modulelibrary/${classId}`}> 
                    <Typography color="textPrimary">Select from Library</Typography>
                </Link>
                :null}
                <Typography color="textPrimary">{module.name}</Typography>
                
            </Breadcrumbs>
            </GridItem>
            <GridItem xs={12} sm={12} md={2}>
            {typeof classId!=='undefined'?
            <Link color="inherit" to={`/admin/home/editmodule/${module._id}/${classId}`}>
                <Button color="primary" >
                    Edit Module
                </Button>
            </Link>
            :<Link color="inherit" to={`/admin/home/editmodule/${module._id}`}>
                    <Button color="primary" >
                        Edit Module
                    </Button>
                </Link>}
            </GridItem>
                                        <Modal
                                            open={openModalAdd}
                                            className={classes.modal}
                                            onClose={handleCloseModal}
                                            aria-labelledby="fb-dialog-title"
                                            //aria-labelledby="form-dialog-title2"
                                            >
                                            <div className={classes.paper1}>
                                              {/* <p>{this.state.errors}</p> */}
                                              <p id = "fb-dialog-title">
                                                Are you sure you want to Add {selectedModule} to session  
                                                </p>
                                                <p>
                                                <Button
                                                  size="small"
                                                  color="primary"
                                                  variant="contained"
                                                  onClick={AssignYesModule}
                                                >
                                                  Yes
                                                </Button>
                                                or
                                                <Button
                                                  size="small"
                                                  color="primary"
                                                  variant="contained"
                                                  onClick={AssignNoModule}
                                                >
                                                  No
                                                </Button>

                                              </p>
                                            </div>
                                        </Modal>
            <GridItem xs={12} sm={12} md={2}>
            {typeof classId!=='undefined'?
                <Button color="rose" area-haspopup="true" aria-controls="simple-menu" onClick={e => AssignModule(module._id, module.name)}>
                    Assign
                </Button>
                :
                    <Button color="rose" area-haspopup="true" aria-controls="simple-menu" onClick={e =>handleButtonClick(e)}>
                        Assign
                    </Button>}
                            <Menu
                            elevation={0}
                            getContentAnchorEl={null}
                            anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                            }}
                            transformOrigin={{ vertical: "top", horizontal: "center" }}
                            id="simple-menu"
                            anchorEl={assignClick}
                            keepMounted
                            open={Boolean(assignClick)}
                            onClose={handleClose}>
                            <MenuItem onClick={handleCurrentClass}>Current Class</MenuItem>
                            <Link to={`/admin/dashboard/createclass/${module._id}`}>
                              <MenuItem >New Class</MenuItem>
                            </Link>
                          </Menu>
                          <Menu
                            elevation={0}
                            getContentAnchorEl={null}
                            anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                            }}
                            id="class-menu"
                            anchorEl={currentClass}
                            keepMounted
                            open={Boolean(currentClass)}
                            onClose={handleClassClose}>

                            {clas.map((item) => (
                              <Link to={`/admin/dashboard/createsession/${item._id}/${module._id}`}> 
                              <MenuItem key = {item._id} >{item.title}</MenuItem>
                              </Link>
                            ))}
                          </Menu>
                          
            </GridItem>
            
            <GridItem xs={12} sm={12} md={12}>

                <Card>
                    <CardHeader color="rose" align="center">
                        <h4 className={classes.cardTitleWhite}>{module.name}</h4>
                        <p className={classes.cardCategoryWhite}>Introduction to Module </p>
                    </CardHeader>
                    <CardBody>
                        <Accordion expanded={expanded === 'panel1'} onChange={handleAccordionChange('panel1')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel2bh-content"
                                        id="panel2bh-header"
                                        >
                                        <Typography className={classes.heading}>Introduction</Typography>
                                        <Typography className={classes.secondaryHeading}>
                                            This tab contains Introduction of the module
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={6}>
                                                <GridContainer>
                                                    <GridItem xs={12} sm={12} md={12}>   
                                                        {module.youtube !== ""? typeof module.youtube !== "undefined"?
                                                                <iframe src={module.youtube}
                                                                allow='autoplay; encrypted-media'
                                                                allowFullScreen={true}
                                                                title='video'
                                                                width='500'
                                                                height='300'
                                                                />:null:null}
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12} md={12}>
                                                    { module.intro_image !== ""?typeof module.intro_image !== "undefined"?
                                                        <iframe src={mongoUrl+module.intro_image} width="500px" height="500px"></iframe>:null:null} 
                                                    </GridItem>
                                                </GridContainer>
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={6}>
                                            
                                                <CKEditor
                                                    required
                                                    editor={ ClassicEditor }
                                                    disabled={true}
                                                    data={module.intro}
                                                                
                                                />
                                            </GridItem>
                                        </GridContainer>    
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                                    { module.simulation_name !== ""?typeof module.simulation_name !== "undefined"?

                                    <p>Simulation Name: {module.simulation_name}</p> :null:null}
                                    </GridItem>
                                    {typeof window.GGBApplet !== 'undefined'?
                                    <GridItem xs={12} sm={12} md={12}>
                                    { module.simulation !==''?  
                                        htmlPage():null}
                                    </GridItem>:null}

                                </GridContainer>
                            </AccordionDetails>
                        </Accordion>
                    </CardBody>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
            {module.level=='1' || module.level=='2' || module.level=='3'?

                <Card>
                    <CardHeader color="rose" align="center">
                        <p className={classes.cardCategoryWhite}>Task </p>
                    </CardHeader>
                    <CardBody>
                    <Accordion expanded={expanded === 'panel2'} onChange={handleAccordionChange('panel2')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel2bh-content"
                                        id="panel2bh-header"
                                        >
                                        <Typography className={classes.heading}>Task</Typography>
                                        <Typography className={classes.secondaryHeading}>
                                            This tab contains Task part of the module
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                                <CKEditor
                                    required
                                    editor={ ClassicEditor }
                                    disabled={true}
                                    data={module.task}
                                                       
                                />

                            </GridItem>
                        </GridContainer>
                        </AccordionDetails>
                    </Accordion>
                    </CardBody>
                    /
                </Card>:null}
            </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <CardHeader color="rose" align="center">
                        <p className={classes.cardCategoryWhite}>BackGround </p>
                    </CardHeader>
                    <CardBody>
                    <Accordion expanded={expanded === 'panel3'} onChange={handleAccordionChange('panel3')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel2bh-content"
                                        id="panel2bh-header"
                                        >
                                        <Typography className={classes.heading}>Background</Typography>
                                        <Typography className={classes.secondaryHeading}>
                                            This tab contains Background part of the module
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                        <GridContainer>
                        <GridItem xs={12} sm={12} md={6}>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={12}>
                                    {typeof module.backGroundYou !== "undefined"? module.backGroundYou!==""?
                                        <iframe src={module.backGroundYou}
                                        allow='autoplay; encrypted-media'
                                        allowFullScreen={true}
                                        title='video'
                                        width='500'
                                        height='300'
                                        />:null:null}
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    { module.backGroundImage !== ""? typeof module.backGroundImage !== "undefined"?
                                    <iframe src={mongoUrl+module.backGroundImage} width="500px" height="500px"></iframe> 
                                    :null:null}  
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                            <GridItem xs={12} sm={12} md={6}>
                                    <CKEditor
                                        required
                                        editor={ ClassicEditor }
                                        disabled={true}
                                        data={module.backGround }
                                                       
                                    />
                            </GridItem>                        
                        </GridContainer>
                        </AccordionDetails>
                        </Accordion>
                    </CardBody>
                </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                {module.level=='1' || module.level=='2'?
                  <Card>
                    <CardHeader color="rose" align="center">
                        <p className={classes.cardCategoryWhite}>Material</p>
                    </CardHeader>
                    <CardBody>
                    <Accordion expanded={expanded === 'panel4'} onChange={handleAccordionChange('panel4')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel2bh-content"
                                        id="panel2bh-header"
                                        >
                                        <Typography className={classes.heading}>Material</Typography>
                                        <Typography className={classes.secondaryHeading}>
                                            This tab contains Material part of the module
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                        <GridContainer>
                        <GridItem xs={12} sm={12} md={6}>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={12}>
                                    {module.materialYou !== ""? typeof module.materialYou !== "undefined"?
                                        <iframe src={module.materialYou}
                                        allow='autoplay; encrypted-media'
                                        allowFullScreen={true}
                                        title='video'
                                        width='500'
                                        height='300'
                                        />:null:null}
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                    {module.materialImage !== ""?typeof module.materialImage !== "undefined"?
                                    <iframe src={mongoUrl+module.materialImage} width="500px" height="500px"></iframe>  
                                    :null:null} 
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                            <GridItem xs={12} sm={12} md={6}>
                                    <CKEditor
                                        required
                                        editor={ ClassicEditor }
                                        disabled={true}
                                        data={module.material}
                                                       
                                    />
                            </GridItem>
                        </GridContainer>
                        </AccordionDetails>
                        </Accordion>
                    </CardBody>
                </Card>:null}
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                {module.level=='1' || module.level=='2'?
                  <Card>
                    <CardHeader color="rose" align="center">
                        <p className={classes.cardCategoryWhite}>Method</p>
                    </CardHeader>
                    <CardBody>
                    <Accordion expanded={expanded === 'panel5'} onChange={handleAccordionChange('panel5')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel2bh-content"
                                        id="panel2bh-header"
                                        >
                                        <Typography className={classes.heading}>Method</Typography>
                                        <Typography className={classes.secondaryHeading}>
                                            This tab contains Method part of the module
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={6}>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                        {module.methodYou !== ""? typeof module.methodYou!=='undefined'?
                                            <iframe src={module.methodYou}
                                            allow='autoplay; encrypted-media'
                                            allowFullScreen={true}
                                            title='video'
                                            width='500'
                                            height='300'
                                            />:null:null}
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                                    { module.methodImage !== ""?typeof module.methodImage !== "undefined"?
                                        <iframe src={mongoUrl+module.methodImage} width="500px" height="500px"></iframe> 
                                        :null:null}  
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={6}>
                                    <CKEditor
                                        required
                                        editor={ ClassicEditor }
                                        disabled={true}
                                        data={module.method}
                                                       
                                    />                           
                            </GridItem>
                           
                        </GridContainer>
                        </AccordionDetails>
                        </Accordion>
                    </CardBody>
                </Card>:null}
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                {module.level=='1'?
                <Card>
                    <CardHeader color="rose" align="center">
                        <p className={classes.cardCategoryWhite}>Analysis </p>
                    </CardHeader>
                    <CardBody>
                    <Accordion expanded={expanded === 'panel6'} onChange={handleAccordionChange('panel6')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel2bh-content"
                                        id="panel2bh-header"
                                        >
                                        <Typography className={classes.heading}>Analysis</Typography>
                                        <Typography className={classes.secondaryHeading}>
                                            This tab contains Analysis part of the module
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={6}>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                        {module.analysisYou !== ""? typeof module.analysisYou!=='undefined'?
                                            <iframe src={module.analysisYou}
                                            allow='autoplay; encrypted-media'
                                            allowFullScreen={true}
                                            title='video'
                                            width='500'
                                            height='300'
                                            />:null:null}
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={12}>
                                        { module.analysisImage !== ""?typeof module.analysisImage !== "undefined"?
                                            <iframe src={mongoUrl+module.analysisImage} width="500px" height="500px"></iframe>   
                                        :null:null}
                                    </GridItem>
                                </GridContainer>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={6}>
                                    <CKEditor
                                        required
                                        editor={ ClassicEditor }
                                        disabled={true}
                                        data={module.analysis}                 
                                    />
                            </GridItem>
                           
                        </GridContainer>
                        </AccordionDetails>
                        </Accordion>
                    </CardBody>
                </Card>:null}
                </GridItem>
            <GridItem xs={12} sm={12} md={4}>
                <Card>
                <CardHeader color="info" align="center">
                    <h4 className={classes.cardCategoryWhite}> About Module </h4>
                </CardHeader>
                <CardBody>
                    <p>Topic:               
                        <CreatableSelect
                            isMulti                                                
                            defaultValue={module.topic}
                            isDisabled={true}
                        />
                    </p>
                    <p>Subject: {module.subject}</p>
                    <p>standard: {module.std}</p>
                    <p>Level: {module.level}</p>
                    <p>Language: {module.language}</p>
                    {/* <p>rating: {module.rating}</p> */}
                    <p>Author: {module.author}</p>
                    <p>Created on: {datepartial(module.date)}</p>


                </CardBody>
                </Card>
            </GridItem>


            


        </GridContainer>: null

        


    );
}